import { Link } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const linkClass =
  'text-sm text-neutral-500 hover:text-neutral-800 transition-colors'

export const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { t } = useLocalization()

  return (
    <footer className="w-full bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-16">
        <Column className="gap-12 md:!flex-row md:items-start md:justify-between">
          <Column className="max-w-sm gap-4">
            <h3 className="text-xl font-medium text-neutral-800">Klayder</h3>
            <p className="text-sm leading-relaxed text-neutral-500">
              {t(
                'A full-service merch partner with a better way to work together.',
                'En fullservicepartner för merch, med ett bättre sätt att jobba tillsammans.'
              )}
            </p>
          </Column>

          <Column className="w-full gap-10 md:!flex-row md:w-auto md:gap-16">
            <Column className="gap-4">
              <h4 className="text-sm font-medium text-neutral-700">
                {t('Product', 'Produkt')}
              </h4>
              <Column className="gap-2">
                <a href="/#how-it-works" className={linkClass}>
                  {t('How it works', 'Hur det fungerar')}
                </a>
                <a href="/#what-we-are" className={linkClass}>
                  {t('What we are', 'Vad vi är')}
                </a>
                <a href="/#why-us" className={linkClass}>
                  {t('Why Klayder', 'Varför Klayder')}
                </a>
                <a href="/#try-sara" className={linkClass}>
                  {t('Try Sara', 'Prova Sara')}
                </a>
                <a href="/#free-samples" className={linkClass}>
                  {t('Free samples', 'Gratisprover')}
                </a>
                <a href="/#faq" className={linkClass}>
                  {t('FAQ', 'Vanliga frågor')}
                </a>
              </Column>
            </Column>

            <Column className="gap-4">
              <h4 className="text-sm font-medium text-neutral-700">
                {t('Company', 'Företag')}
              </h4>
              <Column className="gap-2">
                <Link to={paths.about} className={linkClass}>
                  {t('About us', 'Om oss')}
                </Link>
                <Link to={paths.allProducts} className={linkClass}>
                  {t('Our products', 'Våra produkter')}
                </Link>
                <Link to={paths.contact} className={linkClass}>
                  {t('Talk to the team', 'Prata med teamet')}
                </Link>
              </Column>
            </Column>
          </Column>
        </Column>
      </div>

      <div className="border-t border-stone-300/50">
        <div className="mx-auto max-w-6xl px-4 py-5 md:px-6 md:py-6">
          <Column className="gap-4 text-center md:!flex-row md:items-center md:justify-between md:text-left">
            <p className="text-sm text-neutral-400">
              © {currentYear} Klayder.{' '}
              {t('All rights reserved.', 'Alla rättigheter förbehållna.')}
            </p>
            <Row className="justify-center gap-6 md:justify-end">
              <Link
                to={paths.privacyPolicy}
                className="text-sm text-neutral-400 transition-colors hover:text-neutral-700"
              >
                {t('Privacy policy', 'Integritetspolicy')}
              </Link>
              <Link
                to={paths.termsOfService}
                className="text-sm text-neutral-400 transition-colors hover:text-neutral-700"
              >
                {t('Terms of service', 'Användarvillkor')}
              </Link>
              <Link
                to={paths.cookieConsent}
                className="text-sm text-neutral-400 transition-colors hover:text-neutral-700"
              >
                {t('Cookie policy', 'Cookiepolicy')}
              </Link>
            </Row>
          </Column>
        </div>
      </div>
    </footer>
  )
}
